import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Layout Components
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import CallNowButton from "./components/CallNowButton";

// Pages
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import GalleryPage from "./pages/GalleryPage";
import GiftCardPage from "./pages/GiftCardPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import HealthHistoryForm from "./pages/HealthHistoryForm";
import AdminDashboard from "./pages/AdminDashboard";

// Layout wrapper
const Layout = ({ children }) => {
  return (
    <div className="noise-overlay min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-center" 
        toastOptions={{
          style: {
            background: 'rgba(0, 0, 0, 0.9)',
            color: 'white',
            border: '1px solid rgba(0, 240, 255, 0.3)',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/gallery" element={<Layout><GalleryPage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/gift-cards" element={<Layout><GiftCardPage /></Layout>} />
          <Route path="/payment/success" element={<Layout><PaymentSuccessPage /></Layout>} />
          <Route path="/membership/success" element={<Layout><PaymentSuccessPage /></Layout>} />
          <Route path="/gift-card/success" element={<Layout><PaymentSuccessPage /></Layout>} />
          <Route path="/health-form" element={<Layout><HealthHistoryForm /></Layout>} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <CallNowButton />
    </div>
  );
}

export default App;
